'use client'

import { createContext } from 'react'

export interface WebSocketContextValue {
  userNotifications: any[]
  publicNotifications: any[]
  chats: any[]
  userStatuses: Record<string, boolean>
  isConnected: boolean
  subscribe: (destination: string, onMessage: (msg: any) => void) => void
  sendMessage: (destination: string, body: any) => void
}

export const WebSocketContext = createContext<WebSocketContextValue | null>(null)

export default WebSocketContext
